(function () {
  document.documentElement.classList.add('sz-js');

  /* Apariție lină la scroll */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.sz-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  /* Taburi pentru secțiunea de produse */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-sz-tabs]').forEach(function (section) {
      var buttons = section.querySelectorAll('.sz-tabs__btn');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) {
            var active = b === btn;
            b.setAttribute('aria-selected', active ? 'true' : 'false');
            var panel = document.getElementById(b.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          });
          initReveal(section);
        });
      });
    });
  }

  /* Parallax ușor pe pozele mari + header cu umbră după scroll */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      document.documentElement.classList.toggle('sz-scrolled', window.scrollY > 40);
      if (reduceMotion) return;
      var vh = window.innerHeight;
      document.querySelectorAll('[data-sz-parallax]').forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var strength = parseFloat(el.getAttribute('data-sz-parallax')) || 0.08;
        var offset = ((r.top + r.height / 2) - vh / 2) * -strength;
        el.style.setProperty('--sz-parallax', offset.toFixed(1) + 'px');
      });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* Video-uri Reels: se încarcă doar când ajung pe ecran și rulează doar cât sunt vizibile */
  var reelIO = null;
  function initReels(root) {
    var vids = (root || document).querySelectorAll('.sz-reel__video[data-src]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.src = v.getAttribute('data-src'); v.removeAttribute('data-src'); });
      return;
    }
    if (!reelIO) {
      reelIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.hasAttribute('data-src')) {
              v.src = v.getAttribute('data-src');
              v.removeAttribute('data-src');
            }
            if (!reduceMotion) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.35, rootMargin: '120px 0px' });
    }
    vids.forEach(function (v) { reelIO.observe(v); });
  }

  function init(root) {
    initReveal(root);
    initTabs(root);
    initReels(root);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Editorul de temă Shopify: reinițializează la modificări */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var btn = e.target.closest && e.target.closest('.sz-tabs__btn');
    if (btn) btn.click();
  });
})();
